import * as React from 'react';
import { recordNewRelicAction } from '../ProjectSelling/utils';
import { ProjectSellingApp } from '../ProjectSelling/index';

export const Home = () => {
  React.useEffect(() => {
    recordNewRelicAction('setView', 'View is Configured', {});
  }, []);

  return (
    <div className="main-nucleus-wrapper">
      <ProjectSellingApp />
    </div>
  );
};

Home.propTypes = {
};

Home.displayName = 'HomePage';

Home.defaultProps = {
  name: '',
};